export default __webpack_public_path__ + "static/media/George_W_Bush_0098.d2afcec8.jpg";